import React from 'react';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import configuration from './configuration';
import './styles';
import Index from './pages/IndexPage';
import Amenities from './pages/Amenities';
import Communities from './pages/Communities';
import CommunityDetail from './pages/CommunityDetail';
import CommunityDetailHomes from './pages/CommunityDetail/Homes';
import CommunityDetailPlans from './pages/CommunityDetail/Plans';
import Homes from './pages/Homes';
import MapAndDirections from './pages/MapAndDirections';
import ModelHomes from './pages/ModelHomes';
import HomeDetail from './pages/HomeDetail';
import Plans from './pages/Plans';
import PlanDetail from './pages/PlanDetail';
import Blogposts from './pages/Blogposts';
import BlogpostDetail from './pages/BlogpostDetail';
import NoRoute from './pages/NoRoute';
import CommunityMap from './pages/CommunityMap';
import CommunityPlatMap from './pages/PlatMap';
import DesignCenter from './pages/DesignCenter';
import PhotoGallery from './pages/PhotoGallery';
// import VideoGallery from './pages/VideoGallery';
import AboutTheArea from './pages/AboutTheArea';
import AboutTheDeveloper from './pages/AboutTheDeveloper';
import RealtorContact from './pages/RealtorContact';
import Testimonials from './pages/Testimonials';
import CommunityOverview from './pages/CommunityOverview';
import ContactUs from './pages/ContactUs';
import ContactUsThankYou from './pages/ContactUs/ThankYou';
import HOARequest from './pages/HOARequest';
import HOARequestThankYou from './pages/HOARequest/ThankYou';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import HMLSTerms from './pages/HMLSTerms';

ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack="Local"
      components={[
        { override: 'Index', component: Index },
        { override: 'CommunityDetail', component: CommunityDetail },
        { override: 'CommunityDetailHomes', component: CommunityDetailHomes },
        { override: 'CommunityDetailPlans', component: CommunityDetailPlans },
        { override: 'CommunitiesList', component: Communities },
        { override: 'HomesList', component: Homes },
        { override: 'HomeDetail', component: HomeDetail },
        { override: 'PlansList', component: Plans },
        { override: 'PlanDetail', component: PlanDetail },
        { override: 'BlogpostList', component: Blogposts },
        { override: 'BlogpostDetail', component: BlogpostDetail },
        { override: 'NoRoute', component: NoRoute },
      ]}
      routes={[
        { name: 'amenities', exact: true, path: '/amenities', component: Amenities },
        { name: 'community-map', exact: true, path: '/community-map', component: CommunityMap },
        { name: 'community-plat-map', exact: true, path: '/community-plat-map', component: CommunityPlatMap, sitemapIgnore: true },
        { name: 'design-center', exact: true, path: '/design-center', component: DesignCenter },
        { name: 'photo-gallery', exact: true, path: '/photo-gallery', component: PhotoGallery },
        { name: 'photo-gallery-filtered', exact: true, path: '/photo-gallery/:gallery', component: PhotoGallery, sitemapIgnore: true },
        // { name: 'video-gallery', exact: true, path: '/video-gallery', component: VideoGallery },
        // { name: 'video-gallery-filtered', exact: true, path: '/video-gallery/:gallery',
        // component: VideoGallery, sitemapIgnore: true },
        { name: 'about-the-area', exact: true, path: '/about-the-area', component: AboutTheArea },
        { name: 'about-the-developer', exact: true, path: '/about-the-developer', component: AboutTheDeveloper },
        { name: 'map-and-directions', exact: true, path: '/map-and-directions', component: MapAndDirections },
        { name: 'model-homes', exact: true, path: '/model-homes', component: ModelHomes },
        { name: 'testimonials', exact: true, path: '/testimonials', component: Testimonials },
        { name: 'community-overview', exact: true, path: '/community-overview', component: CommunityOverview },
        { name: 'contact-us', exact: true, path: '/contact-us', component: ContactUs },
        { name: 'contact-us-thank-you', exact: true, path: '/contact-us/thank-you', component: ContactUsThankYou, sitemapIgnore: true },
        { name: 'hoa-request', exact: true, path: '/hoa-request', component: HOARequest },
        { name: 'hoa-request-filtered', exact: true, path: '/hoa-request/:files', component: HOARequest, sitemapIgnore: true },
        { name: 'hoa-request-thank-you', exact: true, path: '/hoa-request/thank-you', component: HOARequestThankYou, sitemapIgnore: true },
        { name: 'privacy-policy', exact: true, path: '/privacy-policy', component: PrivacyPolicy },
        { name: 'realtor-contact', exact: true, path: '/realtor-contact', component: RealtorContact },
        { name: 'terms', exact: true, path: '/terms', component: Terms },
        { name: 'hmls-terms', exact: true, path: '/hmls-terms', component: HMLSTerms },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js